import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { PenIconFilledBlack } from 'shared/components/Icons';
import { confirmBox, getError } from 'utils/appHelpers';
import { removeUserAccountMutation } from 'graphql/user/mutations';
import { API, Auth, graphqlOperation } from 'aws-amplify';
import { useAlert } from 'react-alert';
import { onAuthState } from 'app/actions/authActions';
import AvatarImg from 'shared/components/AvatarImg';
import { getLocalizedPath } from 'utils/languageHelpers';

const Profile = ({ history }) => {
  const { t } = useTranslation();
  const account = useSelector(state => state.account);
  const [fetching, setFetching] = useState(false);
  const dispatch = useDispatch();
  const alert = useAlert();
  const follows = useSelector(state => state.follows);
  const followersCount = Object.keys(follows.followers).length;
  const followingCount = Object.keys(follows.following).length;

  const onEditProfile = () => {
    history.push(getLocalizedPath('/profile/edit'));
  };

  const removeUserAccount = async () => {
    try {
      setFetching(true);
      await API.graphql(graphqlOperation(removeUserAccountMutation, undefined));
      alert.success(t('user_remove_success'));
      dispatch(onAuthState(0));
      Auth.signOut();
    } catch (err) {
      setFetching(false);
      alert.error(getError(err));
    }
  };

  const onRemoveSecondConfirm = () => {
    const options = {
      onSuccess: removeUserAccount,
      title: t('user_remove_title_2'),
      message: <Trans i18nKey='user_remove_text_2' />,
      cancel: t('btn_no'),
      confirm: t('btn_remove_confirm'),
    };
    confirmBox(options);
  };

  const onRemoveAccount = () => {
    const options = {
      onSuccess: () => {
        setTimeout(onRemoveSecondConfirm, 300);
      },
      title: t('user_remove_title'),
      message: t('user_remove_text'),
      cancel: t('btn_no'),
      confirm: t('btn_yes'),
    };
    confirmBox(options);
  };

  const goToFollowListPage = state => {
    history.push(getLocalizedPath(`/profile/list/${state}`));
  };

  return (
    <div>
      <div className='col-12 col-md-6 p-0 m-auto'>
        <h1>{t('title_profile')}</h1>
        <p>{t('sub_title_profile')}</p>
        <div className='mt-15 mb-10 bg-gray-light p-md-15 py-10 px-8 rounded-10 d-flex flex-wrap justify-content-between'>
          <div className='col-12 col-md-none d-flex flex-wrap justify-content-around text-center text-md-left justify-content-md-start'>
            <div className='profile-avatar-edit text-center'>
              <AvatarImg
                width='90px'
                height='90px'
                className='border'
                showNoImageIcon
                picture={account.picture}
                name={account.name}
              />
            </div>
            <div className='ml-md-15 col-12 col-md-none p-0'>
              <h2 className='mb-6 pt-5'>{account.name}</h2>
              <div className='d-flex col-12 col-md-none p-0 justify-content-around mt-3 mt-md-0'>
                <div
                  className='mr-md-49 col-6 col-md-none p-0 border-right border-md-none pointer'
                  tabIndex='-1'
                  role='button'
                  onClick={goToFollowListPage.bind(null, 'followers')}
                >
                  <p className='mb-4 fw-500'>{t('text_followers')}</p>
                  <p className='mb-4'>{followersCount}</p>
                </div>
                <div
                  className='col-6 col-md-none p-0 pointer'
                  tabIndex='-1'
                  role='button'
                  onClick={goToFollowListPage.bind(null, 'following')}
                >
                  <p className='mb-4 fw-500'>{t('text_following')}</p>
                  <p className='mb-4'>{followingCount}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-none'>
            <button
              onClick={onEditProfile}
              className='btn btn-block btn-md-inline btn-md px-10 py-4 lh-initial d-flex align-items-center justify-content-center btn-outline-dark'
            >
              <PenIconFilledBlack className='mr-5' /> {t('btn_edit_profile')}
            </button>
          </div>
        </div>
        <div className='mb-20 pt-40'>
          <button
            disabled={fetching}
            onClick={onRemoveAccount}
            className='btn px-10 py-4 lh-initial d-flex align-items-center justify-content-center btn-xs text-underline'
          >
            {t('btn_remove_account')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
